import { render, staticRenderFns } from "./leftList.vue?vue&type=template&id=fa0c0d2a&scoped=true&"
import script from "./leftList.vue?vue&type=script&lang=js&"
export * from "./leftList.vue?vue&type=script&lang=js&"
import style0 from "./leftList.vue?vue&type=style&index=0&id=fa0c0d2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0c0d2a",
  null
  
)

export default component.exports